import styled from 'styled-components';

export const Container = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.['normal']?.fs14};
  padding: 2rem 0;

  #conteudo_impressao > p > span > span {
    font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};

    line-height: normal;
  }
`;

export const PTitle = styled.p`
  text-align: center;
  margin-bottom: 0.5rem;
  line-height: 100%;
`;

export const P = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  text-align: center;
  margin-top: 1.5rem;
  line-height: 100%;
`;

export const Footer = styled.div`
  p {
    text-align: center;
    margin-top: 1.95in;
    margin-bottom: 0in;
    line-height: 100%;
  }
`;
